import React, { useState } from 'react';
import Footer from '../components/Footer';
import ChatWithUsComponent from '../components/ChatWithUs';
import Navbar from '../components/Navbar';
import Sidebar from "../components/Sidebar";

const Chat = () => {

    const [isOpen, setIsOpen] = useState(false)

    const toggle = () => {
        setIsOpen(!isOpen)
    }

    return (
        <>
            <Sidebar isOpen={isOpen} toggle={toggle} type={false}/>
            <Navbar toggle={toggle} lightTheme={true}/>
            <ChatWithUsComponent />
            <Footer/>
        </>
    )
}

export default Chat;
